import { Component, Host, h, Prop, Element } from '@stencil/core';
import { DomService, SvgType } from '../../services';
import { ButtonAppearance, ButtonFontSize, ButtonType } from '../rcm-button/rcm-button.types';

@Component({
  tag: 'rcm-country-switcher',
  styleUrl: 'rcm-country-switcher.scss',
  shadow: true,
})
export class RcmCountrySwitcher {
  @Prop() countryLabel: string;

  @Prop() countryValue: string;

  @Element() el: HTMLElement;

  private triggerCountrySwitchModal() {
    window.dispatchEvent(new CustomEvent('rcmCountrySwitchOpen'));
  }

  render() {
    return (
      <Host>
        <rcm-button
          icon={`flag-${this.countryValue}` as SvgType}
          onRcmButtonClick={() => this.triggerCountrySwitchModal()}
          text={this.countryLabel}
          type={ButtonType.BUTTON}
          appearance={ButtonAppearance.TERTIARY}
          fontSize={ButtonFontSize.SMALL}
        ></rcm-button>
      </Host>
    );
  }
}
